module.exports = __webpack_public_path__ + "img/1547851765.e6affef2.jpg";